import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// import FetchSourceImages from './FetchSourceImages';
import Banner from './Banner';
import BackgroundImage from './BackgroundImage';
import TwitterFeed from './TwitterFeed';
import Columns from './Columns';
import RemoveLink from './RemoveLink';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import HomeBlockTitle from './HomeBlockTitle';
import SliderComp from './Slider.Competitions';
import SliderImpact from './Slider.OurImpact';
import SelectBox from './SelectBox';
import SelectList from './SelectList';
import NextSlide from './NextSlide';
import Redirect from './Redirect';
import Stats from './Stats';
import LastMeta from './Meta';
import Overviews from './Overviews';
// import StringSplit from './StringSplit';
import BrowserCheck from './BrowserCheck';

// Add the theme behaviors
Drupal.behavior((context) => {
  // eslint-disable-next-line no-new
  // new FetchSourceImages(context);

  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.site-toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      setTimeout(() => {
        element.SmartFooter = new SmartFooter(element, $footprint);
      }, 500);
    }
  });

  // Footer columns
  $('.footerlinks', context).each((i, element) => {
    if (!element.columns) {
      element.columns = new Columns(element, {
        columns: 2,
        item: '.views-row',
        parent: '.view-content',
        divider: 'new-col',
        blockName: 'footerlinks',
      });
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      element.accordionContainer = new AccordionContainer(element);
    }
  });

  // Remove links
  $('.footer-contact', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Twitter Feed
  $('.twitter-feed', context).each((i, element) => {
    if (!element.twitterFeed) {
      element.twitterFeed = new TwitterFeed(element);
    }
  });

  // Banner / Hero
  $body.addClass('no-banner');
  $('.page-top', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new BackgroundImage(element);
      element.banner = new Banner(element);
    }
  });

  // Last meta item
  $('.node-upper-meta .meta-item', context).each((i, element) => {
    if (!element.lastMeta) {
      element.lastMeta = new LastMeta(element);
    }
  });

  // Fix image and video behaviors on Overviews
  $('.overview', context).each((i, element) => {
    if (!element.overview) {
      element.overview = new Overviews(element);
    }
  });

  // Home Page block titles
  $('.home-workshops .block-inner, .home-competitions .block-inner, .home-impact .block-inner').each((i, element) => {
    if (!element.homeBlockTitle) {
      element.homeBlockTitle = new HomeBlockTitle(element);
    }
  });

  // Background images
  $('.home-workshops .views-row, .home-competitions .views-row, .home-impact .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: '.field-image',
      });
    }
  });

  // Dropdown creator
  let selectIdentifier = 1;
  $('.home-workshops .views-row', context).each((i, element) => {
    // Creates a select box from all of the related links.
    if (!element.selectBox) {
      element.selectBox = new SelectList(element, {
        destination: '.node-links',
        placeholder: 'Select Grade Level',
        numerator: selectIdentifier,
      });
      selectIdentifier += 1;
      element.selectBox = new SelectBox(element);
      $(element).closest('.block').addClass('ready');
    }
  });

  // Home Competitions Slider
  $('.home-competitions').each((i, element) => {
    if (!element.sliderComp) {
      element.sliderComp = new SliderComp(element);
      element.sliderComp = new NextSlide(element);
    }
  });

  // Home Our Impact Slider
  $('.home-impact').each((i, element) => {
    if (!element.sliderComp) {
      element.sliderComp = new SliderImpact(element);
      element.sliderComp = new NextSlide(element);
    }
  });

  // Redirect element to .link-read-more
  $('.pods .node-teaser:not(.pt189), .home-competitions .views-row').each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Wrap subtitle
  $('.home-stats .views-row').each((i, element) => {
    if (!element.stats) {
      element.stats = new Stats(element);
    }
  });

  // Split string
  // $('.hero', context).each((i, element) => {
  //   if (!element.stringSplit) {
  //     element.stringSplit = new StringSplit(element);
  //   }
  // });

  setTimeout(() => {
    $body.addClass('delayed');
  }, 300);

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});
